/* eslint-disable no-console */

import { Log, Handler, MessageType } from 'lib/domonda-log';

const handler: Handler = (message) => {
  switch (message.type) {
    case MessageType.DEBUG:
      console.debug(message.text, ...message.metadata);
      break;
    case MessageType.INFO:
      console.info(message.text, ...message.metadata);
      break;
    case MessageType.WARN:
      console.warn(message.text, ...message.metadata);
      break;
    case MessageType.ERROR:
      console.group(message.text);
      console.error(message.error);
      console.info(...message.metadata);
      console.groupEnd();
      break;
  }
};

export const log = new Log(handler);
